<template>
  <div>
    <el-form ref="refAreaForm" :model="form" label-width="30px">
      <div
        v-for="(item, index) in form.domains"
        :key="item.key"
        class="rowBorder"
      >
        <el-row :gutter="10">
          <el-col :span="11">
            <el-form-item
              label-width="0"
              style="margin:0;"
              :prop="'domains.' + index + '.currentCode'"
              :rules="areaRules.currentCode"
            >
              <el-select
                v-model="item.currentCode"
                placeholder="请选择区域"
                style="width:100%;"
                multiple
                @focus="changeIndex(index)"
                @change="changeCode"
              >
                <el-option
                  v-for="(item1, index1) in areaList"
                  :key="index1"
                  :label="item1.countyName"
                  :value="item1.countyCode"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="1" class="iconCount">
            <i>+</i>
          </el-col>

          <el-col :span="12" class="contentBox">
            <el-col :span="areaWidth">
              <el-form-item
                label-width="0"
                style="margin:0;"
                :prop="'domains.' + index + '.unitPrice'"
                :rules="areaRules.unitPrice"
              >
                <el-input
                  v-model.number="item.unitPrice"
                  placeholder="请输入单价"
                  type="number"
                  min="0.00"
                  step="0.01"
                >
                  <i slot="suffix">元/件</i>
                </el-input>
              </el-form-item>
            </el-col>
            <template v-if="isRemove">
              <el-col :span="2">
                <el-button type="text" @click="removeArea(item)">
                  删除
                </el-button>
              </el-col>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "Area",
  data() {
    return {
      areaList: [],
      areaWidth: 22,
      isRemove: false,
      areaRules: {
        unitPrice: [{ type: "number", message: "单价必须为数字值" }],
        currentCode: [{ message: "请选择区域", trigger: "blur" }]
      },
      formIndex: "",
      form: {
        domains: [
          {
            currentCode: "",
            defaultBillingMethod: "3",
            limitEnd: "", //千克/方/件/点计量范围
            limitFrom: 0, //千克/方/件/点计量起始范围,
            points: 0, //百分比
            price: "",
            priceItem: "01", //价格项目（01配送计费，02运输计费）
            priceName: "区域件数计费",
            priceType: "14", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";14：区域件数计费）
            rangeEnd: "", //组合计费 里程终止范围
            rangeFrom: "", //组合计费 里程起始范围
            rangeUnitPrice: 0,
            routelineCode: "", //线路code或者是车型code
            shipmentUserCode: "", //托运人用户code，对应sys_party表code
            unit: 0, //单位（非必传）
            unitPrice: "" //（单价）
          }
        ]
      }
    };
  },

  created() {
    this.getAreaData();
  },
  methods: {
    changeIndex(index) {
      this.formIndex = index;
    },
    changeCode(val) {
      this.$forceUpdate();
    },

    // 删除
    removeArea(item) {
      var delId;
      this.form.domains.map((val, index) => {
        if (val.key == item.key) {
          delId = index;
        }
      });
      if (this.form.domains.length > 1) {
        this.form.domains.splice(delId, 1);
      } else {
        this.areaWidth = 24;
        this.isRemove = false;
        this.$refs.refAreaForm.resetFields();
      }
    },
    // 增加
    addArea() {
      this.form.domains.push({
        key: Date.now(),
        defaultBillingMethod: "3",
        limitEnd: "", //千克/方/件/点计量范围
        limitFrom: 0, //千克/方/件/点计量起始范围,
        points: 0, //百分比
        price: "",
        priceItem: "01", //价格项目（01配送计费，02运输计费）
        priceName: "区域件数计费",
        priceType: "14", //费用类别（0, "公里数计费",1,"重量计费",2, "件数计费",3, "点数计费",4, "体积计费",5, "包车计费",6, "装卸费",7, "车数计费",8, "线路计费",9, "加急费",10, "信息费",11, "代收款手续费",12, "车型费用")13, "综合最大值";14：区域件数计费）
        rangeEnd: "", //组合计费 里程终止范围
        rangeFrom: "", //组合计费 里程起始范围
        rangeUnitPrice: 0,
        routelineCode: "", //线路code或者是车型code
        shipmentUserCode: "", //托运人用户code，对应sys_party表code
        unit: 0, //单位（非必传）
        unitPrice: "" //（单价）
      });
      this.isRemove = true;
      this.areaWidth = 22;
    },
    // 获取区划代码
    getAreaData() {
      request({
        url: "/ntocc-basic-api/partyGroupConfig",
        method: "get",
        params: {
          type: "areaType",
          configKey: "areaCode"
        }
      }).then(response => {
        this.getData(response.data.records[0].configValue);
      });
    },
    //
    getData(val) {
      request({
        url: "/ntocc-basic-api/areaCounty",
        method: "get",
        params: {
          cityCode: val
        }
      }).then(response => {
        this.areaList = response.data.records;
        if (val === "3302") {
          //浙江省
          this.areaList.push({
            cityCode: "新二号桥市场",
            countyCode: "新二号桥市场",
            countyName: "新二号桥市场"
          });
          this.areaList.push({
            cityCode: " 舟山",
            countyCode: " 舟山",
            countyName: " 舟山"
          });
        }
      });
    },
    // 回显
    dataBack() {
      //回调区划件数计费
      this.form.domains.forEach((element, index) => {
        this.form.domains[index].currentCode = element.routelineCode.split(",");
      });
    },
    resetAreaForm() {
      this.$refs.refAreaForm.resetFields();
      this.form.domains.splice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.unitTitle {
  font-size: 14px;
  font-weight: 700;
  color: #606266;
}
.iconCount {
  padding-top: 10px;
  text-align: center;
}
.rowBorder {
  margin-bottom: 10px;
  background: rgba(172, 217, 248, 0.2);
  padding: 10px 20px;
  margin-top: 10px;
}
</style>
